import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Row } from 'reactstrap';
import { ReminderService } from '../../services/ReminderService';
import ButtonComponent from '../ButtonComponent';
import { AssistanceInfoFromReminderResponseDTO } from '../../models/Reminder/AssistanceInfoFromReminderResponseDTO';
import Toast from '../../helpers/Toast';
import InputComponent from '../InputComponent';
import { Utilities } from '../../helpers/Utilities';

type AssistanceInfoFromReminderProps = {
    reminderId: string | null,
    reminderAssistanceNumber: string | null,
}

function AssistanceInfoFromReminder(props: AssistanceInfoFromReminderProps) {

    const reminderService = new ReminderService();
    const intl = useIntl();
    const [assistanceInfo, setAssistanceInfo] = useState<AssistanceInfoFromReminderResponseDTO | null>();

    const [isLoadingAssistanceInfo, setIsLoadingAssistanceInfo] = useState<boolean>(false);

    const AssistanceInfoFromReminder = async (reminderId: number | null) => {
        setIsLoadingAssistanceInfo(true);

        var response = await reminderService.AssistanceInfoFromReminder(reminderId);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoadingAssistanceInfo(false);
            return;
        }
        if (response.success === true && response.obj == null) {
            Toast.Show("info", response.message);
            setIsLoadingAssistanceInfo(false);
            return;
        }

        setAssistanceInfo(response.obj);
        setIsLoadingAssistanceInfo(false);
    }

    useEffect(() => {
        if (props.reminderId !== "" && props.reminderId !== null && props.reminderId !== undefined &&
            props.reminderAssistanceNumber !== "" && props.reminderAssistanceNumber !== null) {
            AssistanceInfoFromReminder(Number(props.reminderId));
        }
    }, [props.reminderId, props.reminderAssistanceNumber])

    return (
        <div>
            <label style={{ margin: "0px" }}></label>

            <Row>
                <InputComponent
                    xl={2}
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={props?.reminderAssistanceNumber}
                    label={intl.formatMessage({ id: "Screens.AssistanceInfoFromReminder.AssistanceNumber" })}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistanceInfo}
                />
                <InputComponent
                    xl={2}
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"date"}
                    value={assistanceInfo?.schedulingDate}
                    label={intl.formatMessage({ id: "Screens.AssistanceInfoFromReminder.SchedulingDate" })}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistanceInfo}
                />
                <InputComponent
                    xl={3}
                    lg={4}
                    md={4}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistanceInfo?.assistanceCurrentStatus ?? "N/A"}
                    label={intl.formatMessage({ id: "Screens.AssistanceInfoFromReminder.AssistanceCurrentStatus" })}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistanceInfo}
                />
            </Row>

            <Row>
                <InputComponent
                    xl={2}
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistanceInfo?.firstInterventionNumber ?? "N/A"}
                    label={intl.formatMessage({ id: "Screens.AssistanceInfoFromReminder.FirstInterventionNumber" })}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistanceInfo}
                />
                <InputComponent
                    xl={2}
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"date"}
                    value={assistanceInfo?.firstInterventionDate}
                    label={intl.formatMessage({ id: "Screens.AssistanceInfoFromReminder.FirstInterventionDate" })}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistanceInfo}
                />
            </Row>

        </div>
    )
}

export default AssistanceInfoFromReminder